import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-32 bg-kiron-black relative overflow-hidden flex items-center justify-center text-center" data-id="element-86">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-87">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[150%] bg-kiron-dark transform rotate-12 opacity-50" data-id="element-88"></div>
        <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[150%] bg-kiron-dark transform -rotate-12 opacity-50" data-id="element-89"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-90">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-6xl font-oswald font-bold text-white mb-10 leading-tight uppercase tracking-wide" data-id="element-91">
          Si no ves resultados, no es falta de esfuerzo.
          <br data-id="element-92" />
          <span className="text-kiron-teal" data-id="element-93">Es falta de dirección.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-94">
          <a href="https://wa.me/541133016499?text=Hola%20quiero%20agendar%20una%20clase%20de%20prueba" target="_blank" rel="noopener noreferrer" className="inline-block bg-kiron-teal text-kiron-black font-oswald font-bold text-2xl px-12 py-5 uppercase tracking-widest hover:scale-105 hover:brightness-110 transition-all duration-300 shadow-[0_0_30px_rgba(0,229,199,0.3)] hover:shadow-[0_0_50px_rgba(0,229,199,0.5)]" data-id="element-95">
            Empezá hoy
          </a>
        </motion.div>
      </div>
    </section>;
}